/* Barras de cobertura por tipo de entidade, porte de `renderCobertura()`
 * (legacy:1301), agora empilhadas por nivel de confianca.
 *
 * A distincao importa: `empresas` tem 18.969 valores TEXTO (copiados da
 * descricao) contra 752 INFERIDA_ALTA (reconstruidos). Uma barra unica esconde
 * exatamente a diferenca entre o que o extrator leu e o que ele deduziu. */

import { intBR, pct } from "../lib/format";

const LEVELS = [
  { key: "TEXTO", label: "texto", opacity: 1 },
  { key: "INFERIDA_ALTA", label: "inferida alta", opacity: 0.66 },
  { key: "INFERIDA_MEDIA", label: "inferida média", opacity: 0.42 },
  { key: "INFERIDA_BAIXA", label: "inferida baixa", opacity: 0.26 },
  { key: "SEM_CONFIANCA", label: "sem confiança", opacity: 0.16 },
];

export interface CoverageRow {
  type_key: string;
  label: string;
  rows: number;
  coverage_pct?: number;
  detail: Record<string, number>;
}

export function CoverageBars({ rows, total }: { rows: CoverageRow[]; total: number }) {
  const max = Math.max(...rows.map((r) => r.rows), 1);

  return (
    <div>
      <div style={{ display: "grid", gap: 7 }}>
        {rows.map((row) => {
          const sum = Object.values(row.detail).reduce((a, b) => a + b, 0) || 1;
          return (
            <div key={row.type_key}
                 style={{ display: "grid", gridTemplateColumns: "116px 1fr 128px",
                          gap: 10, alignItems: "center" }}>
              <span style={{ fontSize: 12.5 }}>{row.label}</span>
              <div style={{ height: 14, background: "var(--surface-2)", borderRadius: 3,
                            overflow: "hidden", display: "flex" }}
                   role="img"
                   aria-label={`${row.label}: ${intBR(row.rows)} linhas, ${pct(row.rows / total)} da base`}>
                {LEVELS.map((level) => {
                  const count = row.detail[level.key] ?? 0;
                  if (!count) return null;
                  const width = (count / sum) * (row.rows / max) * 100;
                  return (
                    <span key={level.key}
                          title={`${level.label}: ${intBR(count)}`}
                          style={{ width: `${width}%`, background: "var(--accent)",
                                   opacity: level.opacity }} />
                  );
                })}
              </div>
              <span className="mono" style={{ fontSize: 11.5, color: "var(--ink-3)",
                                              textAlign: "right" }}>
                {intBR(row.rows)} · {pct(row.rows / total, 0)}
              </span>
            </div>
          );
        })}
      </div>

      <div className="chips" style={{ marginTop: 12 }}>
        {LEVELS.map((level) => (
          <span key={level.key} style={{ display: "inline-flex", alignItems: "center",
                                         gap: 5, fontSize: 11.5, color: "var(--ink-3)" }}>
            <span style={{ width: 10, height: 10, borderRadius: 2,
                           background: "var(--accent)", opacity: level.opacity }} />
            {level.label}
          </span>
        ))}
      </div>
    </div>
  );
}
